import { FormDetails } from '../../empracoTypes';
let captchaTimer: NodeJS.Timeout;

function loadNewCaptcha(formDetails: FormDetails) {
  const captchaImage = document.getElementById(formDetails.spamProtectionDetails.captchaImgId) as HTMLImageElement;
  captchaImage.src = formDetails.spamProtectionDetails.fetchUrlEmporiCaptcha + '?' + new Date().getTime();

}

export function refreshCaptcha(formDetails: FormDetails) {
  if (captchaTimer) {
    loadNewCaptcha(formDetails);
    clearInterval(captchaTimer);
    captchaTimer = setInterval(() => {
      loadNewCaptcha(formDetails);
    }, 300000);// 5min.
  }
}

export function handleCaptcha(formDetails: FormDetails) {

  loadNewCaptcha(formDetails);
  captchaTimer = setInterval(() => {
    loadNewCaptcha(formDetails);
  }, 300000);

  const captchaImage = document.getElementById(formDetails.spamProtectionDetails.captchaImgId) as HTMLImageElement;
  const refreshBtn = captchaImage.nextElementSibling;

  // get refresh button
  refreshBtn?.addEventListener('click', () => {
    refreshCaptcha(formDetails);
  });
}

